export enum ColumnKeys {
  NAME = "name",
  EMAIL = "email",
  ENROLLMENT = "enrollment",
  HUBSPOT_ID = "hubspotContactId",
  LAST_CSAT_SCORE = "lastCSATScore",
  LAST_NPS_SCORE = "lastNPSScore",
  LAST_LEARNING_ACTIVITY = "lastLearningActivity",
  ATTENTION = "attention",
  LAST_INTERVIEW_SCORE = "lastInterviewScore",
  PROGRAM = "program",
  COHORT = "cohort",
  START_DATE = "startDate",
  OUTCOME = "outcome",
  REGISTERED_CLASS = "registeredClass",
  LANGUAGE = "language",
  MENTOR = "mentor",
  ACTIONS = "actions",
}
